<template>
  <div>
    <div
      class="table-values flex flex-nowrap justify-around p-4 pl-11 pt-3 bg-white overflow-wrap border-b border-[#D9D5EC]"
      :class="{ 'bg-[#F2F0F9]': showactions }"
    >
      <p class="w-1/12">
        <base-checkbox
          class="-mt-2"
          label=""
          v-model="terms_of_use"
          :bold="true"
        />
      </p>
      <p
        class="w-4/12 ml-2 overflow-wrap break-all"
      >
        {{ request.message.booking.forwarding3pl.companyname || "---" }}
      </p>
      <p class="w-4/12 ml-2 break-all overflow-wrap">
        {{ 
          request.message.origin.sender
            ? request.message.origin.sender.firstname +
              " " +
              request.message.origin.sender.lastname
            : " " 
         }}
      </p>
      <p class="w-4/12 ml-2 break-all overflow-wrap">
        {{ 
          request.message.origin.sender
            ? request.message.origin.sender.mobile_no
            : "N/A"
         }}
      </p>
      <p class="w-4/12 ml-2 break-all overflow-wrap">
        {{ 
            request.message.origin.sender
            ? request.message.origin.sender.email
            : "N/A"
         }}
      </p>
      <p class="w-4/12 ml-2 break-all overflow-wrap">
        {{ 
            request.message.location
            ? request.message.location.address
            : "N/A"
         }}
      </p>

      <p class="w-4/12 ml-2" v-if="currentTab == 'handsoff'">
        {{ "In Good condition" }}
      </p>

      <p class="w-4/12 ml-2 overflow-wrap">
        <span
          class="rounded-xl overflow-wrap p-2 px-4 text-center bg-[#09B38A]"
          :class="{
            'status-green':
              request.status == 'dispatched' ||
              request.status == 'received' ||
              request.status == 'accepted',
            'status-yellow': request.status == 'loading',
            'status-pale': request.status == 'ready',
            'status-any': request.status == 'pending',
            'status-red':
              request.status == 'accidented' || request.status == 'delayed' || request.status == 'declined',
          }"
          >{{ capitalize(request.status) }}</span
        >
      </p>
      <div v-if="currentTab == 'handsoff'" class="w-1/12 text-right">
        <el-dropdown trigger="click" placement="top" @command="showModal">
          <button
            class="p-2 -mt-2 list-button w-full text-right text-[#6E6893] gap-4 rounded-md"
          >
            <img src="../../../../assets/images/icons/more-action-icon.png" />
          </button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              :disabled="currentTab == 'fulfillment'"
              command="accept"
            >
              <button class="flex flex-nowrap w-full p-1 text-left">
                <div class="pt-2 mr-3">
                  <img
                    src="../../../../assets/images/icons/update-arrows.png"
                    class=""
                  />
                </div>

                <p class="">Accept</p>
              </button>
            </el-dropdown-item>
            <el-dropdown-item
              :disabled="currentTab == 'fulfillment'"
              command="decline"
            >
              <button class="flex flex-nowrap w-full p-1 text-left">
                <div class="pt-2 mr-3">
                  <img
                    src="../../../../assets/images/icons/cancel-icon.png"
                    class=""
                  />
                </div>

                <p class="">Decline</p>
              </button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <AcknowledegedHandoff :showmodal="showAcknowledged" :data="socketdata" />
  </div>
</template>

<script>
import AcknowledegedHandoff from "../Bookings/Modals/AcknowledegedHandoff.vue";

export default {
  components: {
    AcknowledegedHandoff,
  },
  mounted() {},
  props: ["request", "currentTab", "shippingServices"],
  data() {
    return {
      booking: {},
      deliveryDate: new Date(),
      user: {},
      showProcessHandoffModal: false,
      showProcessFulfillmentModal: false,
      showProcessReturnModal: false,
      showReceiptAcknoledgedModal: false,
      showConfirmFulfilment: false,
      showconfirmhandoffmodal: false,
      showRequestSentModal: false,
      showAcknowledged: false,
    };
  },
  methods: {
    capitalize(str) {
      let capitalizedstr = str.charAt(0).toUpperCase() + str.slice(1);

      return capitalizedstr;
    },
    showModal(modal) {
      if (modal == "accept") {
        if (this.currentTab == "handsoff") {
          this.acknowledgeHandoff('accept');
        } else if (this.currentTab == "fulfillment") {
          this.showConfirmFulfilment = true;
        }
      } else if (modal == "decline") {
        this.acknowledgeHandoff('decline');
      }
    },
    showConfirmHandoff(user) {
      this.user = user;
      this.confirmhandoffModal = true;
    },
    async acknowledgeHandoff(action) {
      this.loading = true;

      try {
        let payloadMS = {
          status: action == 'accept' ? "accepted" : action == 'decline' ? 'declined' : 'accepted',
          isRead: true,
        };

        await this.$_acknowledgeRequestMS(this.request._id, payloadMS);

        this.$emit("refetch-requests");

        this.generateToast(`Handoff ${action == 'accept' ? "accepted" : action == 'decline' ? 'declined' : 'accepted'} accepted successfully`, "success");

        this.loading = false;
        this.showmodal = false;
        this.showmodal2 = true;
        action == 'accept' ? this.$emit("acknowledged") : action == 'decline' ? '' : this.$emit("acknowledged")
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  computed: {
    onDispatch() {
      return this.request?.status == "dispatched" ||
        this.request?.status == "accidented" ||
        this.dispatch?.status == "received" ||
        this.request?.status == "delayed"
        ? true
        : false;
    },
    socketdata() {
      return {
        _id: this.request?._id,
        message: {
          user: {
            firstname: this.request?.message.user?.firstname,
            lastname: this.request?.message.user?.lastname,
            email: this.request?.message.user?.email,
            mobile_no: this.request?.message.user?.mobile_no,
          },
          location: {
            address: this.request?.message.location?.address,
            state: this.request?.message.location?.state,
            country: this.request?.message.location?.country,
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.table-values {
  p {
    font-weight: 500;
  }
  .status-green {
    background-color: #09b78a33;
    color: #09b78a;
    font-size: 14px;
  }
  .status-yellow {
    background-color: #ffa60033;
    color: #ffa600;
    font-size: 14px;
  }
  .status-pale {
    background-color: #10233e33;
    color: #10233e;
    font-size: 14px;
  }
  .status-any {
    background-color: #ffa60033;
    color: #ffa600;
    font-size: 14px;
  }
  .status-red {
    background-color: #d7263833;
    color: #d72638;
    font-size: 14px;
  }
}
.modals-wrapper {
  button {
    background-color: #fcc210;
    color: #10233e;
    font-weight: 600;
  }
}
</style>
